import { FRAXLEND_PAIR_ABI } from '@/config/abis/FraxlendPair.abi'
import { poolAbi } from '@/config/abis/poolAbi'
import { rpcUrls, SUPPORTED_CHAINS } from '@/config/chain/constants'
import { APP_ORIGIN } from '@/config/consts'
import { CheckedAddress } from '@/domain/types/CheckedAddress'
import { Token } from '@/domain/types/Token'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { Address, createPublicClient, erc20Abi, http, zeroAddress } from 'viem'

const SECONDS_PER_YEAR = 31536000
const rpcUrl = rpcUrls[0]

type TokenInfo = {
  name?: string
  address: string
  symbol: TokenSymbolEnum
  decimals: number
}

export enum TokenSymbolEnum {
  HYPE = 'HYPE',
  WHYPE = 'WHYPE',
  USDXL = 'USDXL',
  WST_HYPE = 'wstHYPE',
  UBTC = 'UBTC',
  UETH = 'UETH',
  USDE = 'USDe',
  FE_USD = 'feUSD',
  USD_T0 = 'USD₮0',
  PURR = 'PURR',
  LHYPE = 'LHYPE',
  HFUN = 'HFUN',
  MHYPE = 'mHYPE',
  XLHYPE = 'XLHYPE',
  HB_HYPE = 'hbHYPE',
  STKUSDXL = 'stkUSDXL',
  CMETH = 'cmETH',
  SUSDE = 'sUSDe',
  BUDDY = 'BUDDY',
  USOL = 'USOL',
  XAUT0 = 'XAUt0',
  HW_HLP = 'hwHLP',
  HLP0 = 'HLP0',
  WHLP = 'WHLP',
  UPUMP = 'UPUMP',
  KHYPE = 'kHYPE',
  THBILL = 'thBILL',
  USDHL = 'USDHL',
  HAHYPE = 'haHYPE',
  PTKHYPE13NOV2025 = 'PT-kHYPE-13NOV2025',
  PTKHYPE19MAR2026 = 'PT-kHYPE-19MAR2026',
  BEHYPE = 'beHYPE',
  UFART = 'UFART',
  BBHLP = 'bbHLP',
  USDC = 'USDC',
  USDH = 'USDH',
  USDP = 'USDp',
  XHYPE = 'xHYPE',
  SUSN = 'sUSN',
  USDG0 = 'USDG0',
}

const POOL_ADDRESSES = {
  999: '0xceCcE0EB9DD2Ef7996e01e25DD70e461F918A14b',
}

// Token definitions using the TokenSymbolEnum
const tokens: TokenInfo[] = [
  {
    address: '0x9992eD1214EA2bC91B0587b37C3E03D5e2a242C1',
    decimals: 18,
    symbol: TokenSymbolEnum.STKUSDXL,
    name: 'Staked USDXL',
  },
  {
    address: zeroAddress,
    decimals: 18,
    symbol: TokenSymbolEnum.HYPE,
    name: 'HYPE',
  },
  {
    address: '0x2222222222222222222222222222222222222222',
    decimals: 18,
    symbol: TokenSymbolEnum.HYPE,
    name: 'HYPE',
  },
  {
    address: '0x96C6cBB6251Ee1c257b2162ca0f39AA5Fa44B1FB',
    decimals: 18,
    symbol: TokenSymbolEnum.HB_HYPE,
    name: 'Hyperbeat Ultra HYPE',
  },
  {
    address: '0x4fdc8bc634a3ac7911e7edf1f31812891f41772d',
    decimals: 18,
    symbol: TokenSymbolEnum.XLHYPE,
    name: 'Looped Hype Yield',
  },
  {
    address: '0x5555555555555555555555555555555555555555',
    decimals: 18,
    symbol: TokenSymbolEnum.WHYPE,
    name: 'wHYPE',
  },
  {
    address: '0x5555555555555555555555555555555555555555',
    decimals: 18,
    symbol: TokenSymbolEnum.WHYPE,
  },
  {
    address: '0xca79db4B49f608eF54a5CB813FbEd3a6387bC645',
    decimals: 18,
    symbol: TokenSymbolEnum.USDXL,
  },
  { address: '0x94e8396e0869c9F2200760aF0621aFd240E1CF38', decimals: 18, symbol: TokenSymbolEnum.WST_HYPE },
  { address: '0x9FDBdA0A5e284c32744D2f17Ee5c74B284993463', decimals: 18, symbol: TokenSymbolEnum.UBTC },
  { address: '0xBe6727B535545C67d5cAa73dEa54865B92CF7907', decimals: 18, symbol: TokenSymbolEnum.UETH },
  { address: '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34', decimals: 18, symbol: TokenSymbolEnum.USDE },
  { address: '0x02c6a2fA58cC01A18B8D9E00eA48d65E4dF26c70', decimals: 18, symbol: TokenSymbolEnum.FE_USD },
  { address: '0xB8CE59FC3717ada4C02eaDF9682A9e934F625ebb', decimals: 6, symbol: TokenSymbolEnum.USD_T0 },
  { address: '0x9b498c3c8a0b8cd8ba1d9851d40d186f1872b44e', decimals: 18, symbol: TokenSymbolEnum.PURR },
  { address: '0x5748ae796ae46a4f1348a1693de4b50560485562', decimals: 18, symbol: TokenSymbolEnum.LHYPE },
  { address: '0xa320d9f65ec992eff38622c63627856382db726c', decimals: 18, symbol: TokenSymbolEnum.HFUN },
  { address: '0xdabb040c428436d41cecd0fb06bcfdbaad3a9aa8', decimals: 18, symbol: TokenSymbolEnum.MHYPE },
  { address: '0xE6829d9a7eE3040e1276Fa75293Bde931859e8fA', decimals: 18, symbol: TokenSymbolEnum.CMETH },
  { address: '0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2', decimals: 18, symbol: TokenSymbolEnum.SUSDE },
  { address: '0x47bb061C0204Af921F43DC73C7D7768d2672DdEE', decimals: 6, symbol: TokenSymbolEnum.BUDDY },
  { address: '0x068f321Fa8Fb9f0D135f290Ef6a3e2813e1c8A29', decimals: 9, symbol: TokenSymbolEnum.USOL },
  { address: '0xf4D9235269a96aaDaFc9aDAe454a0618eBE37949', decimals: 6, symbol: TokenSymbolEnum.XAUT0 },
  { address: '0x9FD7466f987Fd4C45a5BBDe22ED8aba5BC8D72d1', decimals: 6, symbol: TokenSymbolEnum.HW_HLP },
  { address: '0x1359b05241cA5076c9F59605214f4F84114c0dE8', decimals: 6, symbol: TokenSymbolEnum.WHLP },
  { address: '0x3D75F2BB8aBcDBd1e27443cB5CBCE8A668046C81', decimals: 6, symbol: TokenSymbolEnum.HLP0 },
  { address: '0x27ec642013bcb3d80ca3706599d3cda04f6f4452', decimals: 6, symbol: TokenSymbolEnum.UPUMP },
  { address: '0xfD739d4e423301CE9385c1fb8850539D657C296D', decimals: 18, symbol: TokenSymbolEnum.KHYPE },
  { address: '0xfDD22Ce6D1F66bc0Ec89b20BF16CcB6670F55A5a', decimals: 6, symbol: TokenSymbolEnum.THBILL },
  { address: '0xb50A96253aBDF803D85efcDce07Ad8becBc52BD5', decimals: 6, symbol: TokenSymbolEnum.USDHL },
  { address: '0xFde5B0626fC80E36885e2fA9cD5ad9d7768D725c', decimals: 18, symbol: TokenSymbolEnum.HAHYPE },
  { address: '0x311dB0FDe558689550c68355783c95eFDfe25329', decimals: 18, symbol: TokenSymbolEnum.PTKHYPE13NOV2025 },
  { address: '0xea84ca9849D9e76a78B91F221F84e9Ca065FC9f5', decimals: 18, symbol: TokenSymbolEnum.PTKHYPE19MAR2026 },
  { address: '0xd8FC8F0b03eBA61F64D08B0bef69d80916E5DdA9', decimals: 18, symbol: TokenSymbolEnum.BEHYPE },
  { address: '0x3B4575E689DEd21CAAD31d64C4df1f10F3B2CedF', decimals: 6, symbol: TokenSymbolEnum.UFART },
  { address: '0x4bB19336C973506B9405Db586b7AEE302a7CbCFc', decimals: 18, symbol: TokenSymbolEnum.BBHLP },
  { address: '0xb88339CB7199b77E23DB6E890353E22632Ba630f', decimals: 6, symbol: TokenSymbolEnum.USDC },
  { address: '0x111111a1a0667d36bD57c0A9f569b98057111111', decimals: 6, symbol: TokenSymbolEnum.USDH },
  { address: '0xBE65F0F410A72BeC163dC65d46c83699e957D588', decimals: 18, symbol: TokenSymbolEnum.USDP },
  { address: '0xac962fa04bf91b7fd0dc0c5c32414e0ce3c51e03', decimals: 18, symbol: TokenSymbolEnum.XHYPE },
  { address: '0x34a2798D47b238A7CbA9D87D49618DEE6C4D999F', decimals: 18, symbol: TokenSymbolEnum.SUSN },
  { address: '0x9522133c663ba8C2a8A7b4F63Dd2aC8DccCe1505', decimals: 6, symbol: TokenSymbolEnum.USDG0 },
]

export const tokenList = tokens

// Validate that all TokenSymbolEnum values have token info
function validateTokenEnumCoverage(): void {
  const enumValues = Object.values(TokenSymbolEnum)
  const missingTokens = enumValues.filter((enumValue) => !tokens.some((token) => token.symbol === enumValue))

  if (missingTokens.length > 0) {
    console.error(`Missing token info for these symbols: ${missingTokens.join(', ')}`)
  }
}

// Run validation (will log errors if any tokens are missing)
validateTokenEnumCoverage()

// Create base TokenAddresses object
const baseTokenAddresses = Object.values(TokenSymbolEnum).reduce((acc, symbol) => {
  // Start with empty object
  return { ...acc, [symbol]: undefined }
}, {}) as Record<TokenSymbolEnum, Token | undefined>

for (const token of tokens) {
  baseTokenAddresses[token.symbol] = new Token({
    name: token.name || token.symbol,
    address: CheckedAddress(token.address),
    decimals: token.decimals,
    symbol: TokenSymbol(token.symbol),
    unitPriceUsd: '0',
  })
}

export const TokenAddresses = new Proxy(baseTokenAddresses, {
  get(target, prop) {
    const value = target[prop as TokenSymbolEnum]
    if (value === undefined) {
      throw new Error(`Token for symbol ${String(prop)} is not defined`)
    }
    return value
  },
}) as Record<TokenSymbolEnum, Token>

/**
 * Get token by symbol
 * @param symbol The token symbol from TokenSymbolEnum
 * @returns The Token object
 * @throws Error if token is not found
 */
export function getTokenBySymbol(symbol: TokenSymbolEnum): Token {
  return TokenAddresses[symbol]
}

/**
 * Get token address by symbol
 * @param symbol The token symbol from TokenSymbolEnum
 * @returns The token address
 * @throws Error if token is not found
 */
export function getAddressBySymbol(symbol: TokenSymbolEnum): string {
  return TokenAddresses[symbol].address
}

const tokensByChainId: Record<number, TokenInfo[]> = {
  999: tokens,
}

export default function getTokenByAddress(chainId: number, address: string): TokenInfo | undefined {
  return tokensByChainId[chainId]?.find((token) => token.address.toLowerCase() === address.toLowerCase())
}

export async function getTokenSymbolOrFetch(chainId: number, address: string): Promise<string> {
  let tokenSymbol = 'HYPE' // Default symbol

  try {
    const token = getTokenByAddress(chainId, address)

    if (token?.symbol) {
      tokenSymbol = token?.symbol as string
    } else {
      const client = createPublicClient({
        chain: SUPPORTED_CHAINS.find((chain) => chain.id === chainId),
        transport: http(rpcUrl, {
          fetchOptions: {
            headers: {
              Origin: APP_ORIGIN,
            },
          },
        }),
      })

      const asset = address as `0x${string}`

      // Get token symbol directly from the token contract
      const symbol = await client.readContract({
        address: asset,
        abi: erc20Abi,
        functionName: 'symbol',
      })

      if (symbol) {
        tokenSymbol = symbol as string
      }
    }
  } catch (error) {
    console.error('Error fetching token symbol:', error)
  }

  return tokenSymbol
}

export async function getPooledAPY(
  chainId: number,
  asset: Address,
): Promise<{ depositAPY: string; borrowAPY: string }> {
  let depositAPY = '0.00'
  let borrowAPY = '0.00'

  if (asset && POOL_ADDRESSES[chainId as keyof typeof POOL_ADDRESSES]) {
    try {
      // Create a public client to interact with the chain
      const client = createPublicClient({
        chain: SUPPORTED_CHAINS.find((chain) => chain.id === chainId),
        transport: http(rpcUrl, {
          fetchOptions: {
            headers: {
              Origin: APP_ORIGIN,
            },
          },
        }),
      })
      // Get reserve data from the pool contract
      const poolAddress = POOL_ADDRESSES[chainId as keyof typeof POOL_ADDRESSES]
      const reserveData = await client.readContract({
        address: poolAddress as `0x${string}`,
        abi: poolAbi,
        functionName: 'getReserveData',
        args: [asset],
      })

      if (reserveData) {
        let variableBorrowRate = 0
        let liquidityRate = 0

        if (reserveData.currentVariableBorrowRate && Number(reserveData.currentVariableBorrowRate) > 0) {
          variableBorrowRate = Number(reserveData.currentVariableBorrowRate) / 1e27
        }

        if (reserveData.currentLiquidityRate && Number(reserveData.currentLiquidityRate) > 0) {
          liquidityRate = Number(reserveData.currentLiquidityRate) / 1e27
        }

        // Convert to APY percentage using the formula: ((APR/secondsPerYear + 1)^secondsPerYear) - 1
        const borrowAPYValue = ((variableBorrowRate / SECONDS_PER_YEAR + 1) ** SECONDS_PER_YEAR - 1) * 100
        const lendAPYValue = ((liquidityRate / SECONDS_PER_YEAR + 1) ** SECONDS_PER_YEAR - 1) * 100

        depositAPY = lendAPYValue.toFixed(2)
        borrowAPY = borrowAPYValue.toFixed(2)
      }
    } catch (error) {
      console.error('Failed to fetch reserve data:', error)
    }
  }

  return {
    depositAPY,
    borrowAPY,
  }
}

export async function getIsolatedAPY(
  chainId: number,
  pairAddress: Address,
): Promise<{ borrowAPY: number; depositAPY: number; collateralContractAddress: string; assetContractAddress: string }> {
  const publicClient = createPublicClient({
    chain: SUPPORTED_CHAINS.find((chain) => chain.id === chainId),
    transport: http(rpcUrl, {
      fetchOptions: {
        headers: {
          Origin: APP_ORIGIN,
        },
      },
    }),
  })

  const results = await publicClient.multicall({
    allowFailure: false,
    contracts: [
      {
        address: pairAddress,
        abi: FRAXLEND_PAIR_ABI,
        functionName: 'collateralContract',
      },
      {
        address: pairAddress,
        abi: FRAXLEND_PAIR_ABI,
        functionName: 'asset',
      },
      {
        address: pairAddress,
        abi: FRAXLEND_PAIR_ABI,
        functionName: 'getPairAccounting',
      },
      {
        address: pairAddress,
        abi: FRAXLEND_PAIR_ABI,
        functionName: 'currentRateInfo',
      },
    ],
  })

  const collateralContractAddress = results[0]
  const assetContractAddress = results[1]
  const accountingDetails = results[2]
  const rateInfoDetails = results[3]

  const totalAssetAmount = accountingDetails?.[0] || 0n
  const totalAssetShares = accountingDetails?.[1] || 0n
  const totalBorrowShares = accountingDetails?.[3] || 0n

  const utilization = totalAssetAmount > 0n ? Number((totalBorrowShares * 1000000n) / totalAssetShares) / 10000 : 0

  // Calculate APY using rate info
  const ratePerSec = rateInfoDetails?.[3] ? Number(rateInfoDetails[3]) / 1e18 : 0
  const feeToProtocolRate = rateInfoDetails?.[1] ? Number(rateInfoDetails[1]) / 1e5 : 0

  const borrowAPY = ratePerSec > 0 ? (Math.exp(ratePerSec * SECONDS_PER_YEAR) - 1) * 100 : 0

  const depositAPY = borrowAPY * (utilization / 100) * (1 - feeToProtocolRate)

  return {
    borrowAPY,
    depositAPY,
    collateralContractAddress,
    assetContractAddress,
  }
}
